import { render } from "./CmsAddonsSection.vue?vue&type=template&id=8cd59b26&scoped=true"
import script from "./CmsAddonsSection.vue?vue&type=script&lang=js"
export * from "./CmsAddonsSection.vue?vue&type=script&lang=js"

import "./CmsAddonsSection.vue?vue&type=style&index=0&id=8cd59b26&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cd59b26"]])

export default __exports__